// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from './store/'
import VueHead from 'vue-head'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import VueYoutube from 'vue-youtube'

Vue.config.productionTip = false

// Initialize Firebase
// ★本番向け
var config = {
  apiKey: 'AIzaSyCrcW_Z3HyrfEEaCIy2D5VhHgLQqxQvTLc',
  authDomain: 'heisei.firebaseapp.com',
  databaseURL: 'https://heisei.firebaseio.com',
  projectId: 'heisei',
  storageBucket: 'heisei.appspot.com',
  messagingSenderId: '523379122503'
}

// ★開発向け
// var config = {
//   apiKey: 'AIzaSyDH_dwAAiPZOUkWn-2dBW9FGJVZRo8fvdw',
//   authDomain: 'heisei-dev.firebaseapp.com',
//   databaseURL: 'https://heisei-dev.firebaseio.com',
//   projectId: 'heisei-dev',
//   storageBucket: 'heisei-dev.appspot.com',
//   messagingSenderId: '546866500859'
// }

firebase.initializeApp(config)
export const db = firebase.firestore()
export const providerTwitter = new firebase.auth.TwitterAuthProvider()
export const providerFacebook = new firebase.auth.FacebookAuthProvider()
export const providerGoogle = new firebase.auth.GoogleAuthProvider()

Vue.use(Vuetify, {
  theme: {
    primary: '#F44336',
    secondary: '#b0bec5',
    accent: '#FF6D00',
    info: '#FF6D00',
    error: '#b71c1c'
  }
})
Vue.use(Croppa)
Vue.use(VueHead)
Vue.use(VueYoutube)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js